'use strict';

const MemberModel = require('common/domain/entity/member');
const GroupMemberIconView = require('common/ui/view/group/member-icon');
const GroupMemberNameView = require('common/ui/view/group/member-name');
const MemberItemEditViewTemplate = require('balus/ui/template/body/group/modal/member-edit/item.hbs');
const Mn = require('backbone.marionette');

/**
 * グループメンバーの編集画面 (Tableの一行分)
 *
 * @type {*|Object|void}
 */
module.exports = Mn.View.extend({
    model: MemberModel,
    tagName: 'li',
    className: 'list-item',
    template: MemberItemEditViewTemplate,
    ui: {
        roleSelector: 'select.form-control.role',
    },
    events: {
        'click .member-suspend': 'suspend',
        'click .member-resume': 'resume'
    },
    regions: {
        icon: '.list-item-icon',
        title: '.list-item-header-title',
    },

    bindings: {
        'select.role': 'role'
    },
    modelEvents: {
        'change:suspended': 'render',
        'change': 'memberChanged'

    },

    templateContext: function() {
        const context = this.getOption('context');
        const user = context.getUser();
        return {
            role: this.model.getRole(),
            groupRoles: this.getOption('groupRoles')
                .chain()
                .filter(role => role.isSelectable())
                .map(role => {
                    return {
                        id: role.id,
                        name: role.getName()
                    }
                })
                .value(),
            isEditable: true,
            isSuspendable: user.id !== this.model.id,
            isSuspended: this.model.isSuspended()
        };
    },

    onRender: function() {
        const context = this.getOption('context');
        const user = context.getUser();
        if (user.id === this.model.id) {
            this.ui.roleSelector.attr('disabled', 'disabled');
        }
        this.showChildView('icon', new GroupMemberIconView({model: this.model}));
        this.showChildView('title', new GroupMemberNameView({model: this.model}));

        this.stickit();
    },

    suspend: function() {
        this.model.set({suspended: true});
    },

    resume: function() {
        this.model.set({suspended: false});
    },

    memberChanged: function(){
        this.trigger('change:member');
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/modal/member-edit/item.js